import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import * as CartUtils from "@omni/utils/cart.utils";

import { PromotionItems } from "@/components/Cart/ShoppingCart/promotionItems/promotionItems.component";

import TotalsBlockComponent from "../totalsBlock/totalsBlock.component";

type TotalsOverviewProps = { shoppingCart?: Cart | null };

const TotalsOverview = ({ shoppingCart }: TotalsOverviewProps) => {
    const deliveryProducts = shoppingCart?.items.filter(
        (i) =>
            i.deliveryType === DeliveryType.HomeDelivery &&
            !CartUtils.productIsAdditionalService(shoppingCart?.items, i.id)
    );

    const deliveryCost = deliveryProducts?.length
        ? (shoppingCart?.deliveryCost ?? 0)
        : undefined;
    return (
        <div>
            <section>
                {
                    <TotalsBlockComponent
                        deliveryCost={deliveryCost}
                        discountTotal={CartUtils.getDiscountTotal(shoppingCart)}
                        giftCardTotal={CartUtils.getGiftCardTotal(shoppingCart)}
                        serviceTotal={CartUtils.getServiceTotal(shoppingCart)}
                        subTotal={shoppingCart?.subTotalPrice}
                        totalPrice={shoppingCart?.totalPrice}
                    />
                }
            </section>
            <section>
                <PromotionItems promotions={shoppingCart?.promotions} />
            </section>
        </div>
    );
};

export { TotalsOverview };
